<template>
  <div
    :class="`content-width partner_${partnerClass}`"
  >
    <v-container
      :fluid="$vuetify.breakpoint.lgAndDown"
      style="height: 100%;"
    >
      <a
        :href="partnerExitUrl"
        target="_blank"
        class="logo"
        :class="swapLogos && 'right'"
      >
        <img
          :src="logoImg"
          :alt="`${partnerText || 'Quotezone'} Logo`"
        >
      </a>

      <branding-logo
        v-if="showBrandingHeaderLogo"
        :branding-type="config.brandingType"
        :filled="config.brandingHeaderLogoFilled"
        :class="!swapLogos && 'right'"
        data-unit-test="branding-logo"
      />
    </v-container>
  </div>
</template>

<script>
import { inject } from '@vue/composition-api';

export default {
  name: 'header-logos',
  inject: ['config', 'constants'],
  computed: {
    showBrandingHeaderLogo () {
      return this.config.brandingHeaderLogo || this.isCobrandShown;
    },
    partnerExitUrl () {
      return this.config.partnerExitUrl;
    },
    partnerText () {
      return this.config.partnerText;
    },
    logoImg () {
      const { partnerImage } = this.config;
      if (!partnerImage) return this.constants.DEFAULT_LOGO;
      return partnerImage.indexOf('/') === 0 ? `/quotezone-ui${partnerImage}` : partnerImage;
    },
    swapLogos () {
      return !!this.config.logoSwap;
    },
    partnerClass () {
      switch (this.config.partner) {
        // TotallyMoney
        case '8ccd42a8b26f15ceb5612106ea0f41fe':
          return '8ccd42a8b26f15ceb5612106ea0f41fe';
        default:
          return 'default';
      }
    },
  },
  setup () {
    const abTastyControllerUI = inject('abTastyControllerUI');

    return {
      ...abTastyControllerUI,
    };
  },
};
</script>

<style lang="scss" scoped>
div {
  .container {
    display: flex;
    align-items: center;
    padding: 0 32px;

    @media screen and (max-width: 960px) {
      padding: 0 12px;
    }
  }

  .logo {
    height: 100%;
    display: flex;

    img {
      max-width: 100%;
      height: 100%;
      width: auto;
    }
  }
}

.right {
  order: 2;
  margin-left: auto;
}
</style>

<style lang="scss" scoped src="@/assets/scss/header/header_partners.scss"/>
